const VARIANTS = {
  dark:     { src: '/Aevara-Header-Logo.svg', aspect: 655.913 / 120.656 }, // ≈ 5.436
  light:    { src: '/aevara-logo-light.svg', aspect: 200 / 48 },           // ≈ 4.167
  markOnly: { src: '/aevara-mark.svg',       aspect: 1 },
};

export default function AevaraLogo({ variant = 'dark', height = 32 }) {
  const { src, aspect } = VARIANTS[variant] ?? VARIANTS.dark;
  return (
    <img
      src={src}
      alt="Aevara"
      height={height}
      width={Math.round(height * aspect)}
      style={{ display: 'block', flexShrink: 0 }}
    />
  );
}
